<template>
  <div class="mb-10">
    <v-row align="stretch">
      <v-col cols="12" md="4" class="d-flex flex-column">
        <v-card
          elevation="3"
            @click="selectRefType(REFERRAL_STEPS.iHaveTheReferral)"
            :disabled="isSubmitting"
          class="flex d-flex flex-column"
        >
          <v-card-title>
            <span class="primary--text text-break">
              <v-icon color="primary" size="32" class="mr-2">
                mdi-desktop-classic
              </v-icon>
              {{ $_t('I have an e-referral') }}
            </span>
          </v-card-title>
          <div class="divider-line"></div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              class="text-capitalize"
              @click="selectRefType(REFERRAL_STEPS.iHaveTheReferral)"
              :disabled="isSubmitting"
            >
              {{ $_t('Choose') }}
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" class="d-flex flex-column">
        <v-card
          elevation="3"
          @click="selectRefType(REFERRAL_STEPS.iHaveThePaperReferral)"
          :disabled="isSubmitting"
          class="flex d-flex flex-column"
        >
          <v-card-title>
            <span class="primary--text text-break">
              <v-icon color="primary" size="32" class="mr-2">
                mdi-file-document-edit-outline
              </v-icon>
              {{ $_t('I have a paper referral') }}
            </span>
          </v-card-title>
          <v-card-text class="flex">
            {{
              $_t(
                'Please prepare your paper referral to provide some details written on it'
              )
            }}
          </v-card-text>
          <div class="divider-line"></div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              class="text-capitalize"
              @click="selectRefType(REFERRAL_STEPS.iHaveThePaperReferral)"
              :disabled="isSubmitting"
            >
              {{ $_t('Choose') }}
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" class="d-flex flex-column">
        <v-card
          elevation="3"
          @click="selectRefType(REFERRAL_STEPS.iDontHaveTheReferral)"
          :disabled="isSubmitting"
          class="flex d-flex flex-column"
        >
          <v-card-title>
            <span class="primary--text text-break">
              <v-icon color="primary" size="32" class="mr-2">
                mdi-file-outline
              </v-icon>
              {{
                $_t("I don't have a referral")
              }}
            </span>
          </v-card-title>
          <v-card-text class="flex">
            {{
              $_t(
                'MR and USG do not rquire a referral'
              )
            }}
            <br>
            {{
              $_t(
                'Please note that there is a limited number of procedures available without a referral'
              )
            }}
          </v-card-text>
          <div class="divider-line"></div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              class="text-capitalize"
              @click="selectRefType(REFERRAL_STEPS.iDontHaveTheReferral)"
              :disabled="isSubmitting"
            >
              {{ $_t('Choose') }}
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ROUTE_NAMES from '@/store/consts/route-names';
import REFERRAL_STEPS from '@/store/consts/referral-steps';
import config from '@/config';
import { onMounted, ref } from '@vue/composition-api';
import { bookingStore } from '@/store/booking-store';
import rest from '@/plugins/rest'

export default {
  name: 'ReferralStart',
  setup(_, context) {
    const init = () => {
      bookingStore.clearStore();
      bookingStore.setShowStepper(false);
    };

    onMounted(init);

    const isSubmitting = ref(false);
    const goToRoute = (routeName) => {
      context.root.$router.push(routeName).catch(() => {});
    };
    const selectRefType = (refType) => {
      if (isSubmitting.value) {
        return;
      }
      isSubmitting.value = true;
      bookingStore.setReferralStep(refType);

      let route = ROUTE_NAMES.procedures.path;
      let refName = '';
      switch (refType) {
        case REFERRAL_STEPS.iHaveTheReferral:
          route = ROUTE_NAMES.eReferralsSearch.path;
          refName = 'electronic';
          break;
        case REFERRAL_STEPS.iHaveThePaperReferral:
          refName = 'paper';
          break;
        case REFERRAL_STEPS.iDontHaveTheReferral:
          refName = 'none';
          break;
      }

      const setReferralTypeUrl = bookingStore.getState().apiUrls
        .setReferralTypeUrl;
      rest.post(setReferralTypeUrl, {
        referralTypeName: refName,
        referralTypeId: '' + refType
      }).then(() => {
        goToRoute(route);
      }).catch((err) => {
        console.error('Failed to save referral type, reloading...', err);
        // reload the page to re-initialize the booking process and tracking
        window.location.reload();
      }).finally(() => {
        isSubmitting.value = false;
      });
    };
    return {
      REFERRAL_STEPS,
      ROUTE_NAMES,
      config,
      goToRoute,
      selectRefType,
      isSubmitting
    };
  }
};
</script>
